<div class="row pricing">
  <div class="col-12 p-0">
    <p class="mb-0">Monthly Subscription</p>
    <p class="selected-price mb-0"><b>Under &#8377; {{selectedPrice}}</b></p>
    <!-- <input (change)="priceFilterChanged($event)" value="{{selectedPrice/multipleOf}}" type="range" class="form-range"
      [min]="minPrice" [max]="maxPrice" [step]="10" id="priceRange"> -->
    <ngx-slider [value]="selectedPrice/multipleOf" (userChangeEnd)="priceFilterChanged($event)" [options]="defaultOption"></ngx-slider>
    <div class="d-flex justify-content-between">
      <span class="price-label">{{minPrice}}K</span>
      <span class="price-label">{{maxPrice}}K</span>
    </div>
  </div>
  <hr>
</div>